import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import parse from 'date-fns/parse';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import './Countdown.module.css';

const isValidDate = d => {
  return d instanceof Date && !isNaN(d);
};
const Countdown = ({ endtime }) => {
  const { t } = useTranslation();
  const end = new Date(parse(endtime));
  const isEndValid = isValidDate(end);
  const [timeRemaining, setTimeRemaining] = useState(
    isEndValid ? end - Date.now() : null
  );

  useEffect(() => {
    if (isEndValid) {
      const timeout = setTimeout(() => {
        setTimeRemaining(end - Date.now());
      }, 1000);
      return () => {
        clearTimeout(timeout);
      };
    }
  });

  if (!endtime || !isEndValid) {
    return null;
  }

  var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
  var hours = Math.floor(
    (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

  return (
    <div styleName="countdown">
      <Grid
        direction="x"
        primaryAlignment="align-center"
        hasContainer={false}
        styles={{ height: '100%' }}
      >
        <Cell
          smallSize={6}
          mediumSize={5}
          largeSize={4}
          contentAlignment="align-children-middle"
        >
          <div styleName="center">
            <p styleName="time">{days}</p>
            <p>{t('Days')}</p>
          </div>
        </Cell>
        <Cell
          smallSize={6}
          mediumSize={5}
          largeSize={4}
          contentAlignment="align-children-middle"
        >
          <div styleName="center">
            <p styleName="time">{hours}</p>
            <p>{t('Hours')}</p>
          </div>
        </Cell>
        <Cell
          smallSize={6}
          mediumSize={5}
          largeSize={4}
          contentAlignment="align-children-middle"
        >
          <div styleName="center">
            <p styleName="time">{minutes}</p>
            <p>{t('Minutes')}</p>
          </div>
        </Cell>
        <Cell
          smallSize={6}
          mediumSize={5}
          largeSize={4}
          contentAlignment="align-children-middle"
        >
          <div styleName="center">
            <p styleName="time">{seconds}</p>
            <p>{t('Seconds')}</p>
          </div>
        </Cell>
      </Grid>
    </div>
  );
};

Countdown.propTypes = {
  endtime: PropTypes.string.isRequired
};

export default DisplayComponent(Countdown);
